/* eslint-disable max-len */
import React from "react"
import Filter from "./Components/Filter";
import InvoiceList from "./Components/InvoiceList";
import { formatAdjustedDate } from '../../../../../../CommonMethods/formatDate';
import {
    ShimmerTitle,
} from 'react-shimmer-effects';
export default function StudentStatement({
    studentDetails, 
    tabs, 
    searchParams,
    setSearchParams, 
    financialYearsDropdownOptions, 
    setAcademicYearsDropdownOptions,
    academicYearsDropdownOptions,
    startDate,
    endDate,
    setStartDate, 
    setEndDate,
    getStudentData,
    toastErrorMessage,
    setToastErrorMessage,
    apiIsLoading,
    setApiIsLoading,
    studentInvoiceDetails,
    currentFinacialYear,
    setInvoiceStatus,
    startDateDisplay,
    endDateDisplay}){

    /* The code is creating a current date object using the `Date` constructor. */
    const currentDate = new Date();
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const formattedDate = currentDate.toLocaleDateString('en-US', options);

    return (
        <div className="">
            <div className="relative">
                <div
                    className="z-20 bg-white mt-5"
                    id="tabs-studentStatement"
                    role="tabpanel"
                    aria-labelledby="tabs-studentStatement-tab"
                >
                    <div className="pb-[32px] w-[850px] 2xl:px-0 2xl:w-[80%] mx-auto">
                        <Filter tabs={tabs} setSearchParams={setSearchParams} financialYearsDropdownOptions={financialYearsDropdownOptions}
                            setStartDate={setStartDate} setEndDate={setEndDate} startDate={startDate} endDate={endDate} setInvoiceStatus={setInvoiceStatus}
                            currentFinacialYear={currentFinacialYear} searchParams={searchParams} getStudentData={getStudentData}  setApiIsLoading={setApiIsLoading}
                            setAcademicYearsDropdownOptions={setAcademicYearsDropdownOptions} academicYearsDropdownOptions={academicYearsDropdownOptions}
                            toastErrorMessage={toastErrorMessage} setToastErrorMessage={setToastErrorMessage} apiIsLoading={apiIsLoading}/>
                        <div className="inline-flex w-[100%] h-[4.25rem] border border-[#d0d5dd] mt-[18px] py-[6px]">
                            <div className="flex flex-col items-center gap-1 pl-[24px]">
                                <div className="total_invoice_amount text-black leading-6">Total Invoice Amount </div>
                                <div className="text-black text-[.9375rem] font-semibold leading-6">{studentInvoiceDetails?.total_invoice_amount?.toFixed(2) ||'00.00'}</div>
                            </div>
                            <div className="flex flex-col items-center gap-1 ml-[48px]">
                                <div className="total_received_amount text-black leading-6">Total Collected Amount</div>
                                <div className="text-black text-[.9375rem] font-semibold leading-6">{studentInvoiceDetails?.total_received_amount?.toFixed(2) ||'00.00'}</div>
                            </div>
                            <div className="flex flex-col items-center gap-1 pr-[24px] ml-[48px]">
                                <div className="due_amount_as_on__current_date_ text-black leading-6">Total Invoice Due</div>
                                <div className="text-black text-[.9375rem] font-semibold leading-6">{studentInvoiceDetails?.total_invoice_amount ? ((studentInvoiceDetails?.total_invoice_amount || 0) - (studentInvoiceDetails?.total_received_amount || 0)).toFixed(2) : '0.00'}</div>
                            </div>
                        </div>
                    </div>
                    <div className="flex">
                        <p className="flex text-[#031624] leading-[1.875rem] 2xl:w-[95%] 2xl:mx-auto mb-2">
                            <span class="text-[20px] font-semibold ">Invoices List</span> 
                            {startDateDisplay && !apiIsLoading ? <span class="ml-2"> (from {formatAdjustedDate(startDateDisplay)} to {formatAdjustedDate(endDateDisplay)})</span>:<ShimmerTitle line={1} gap={6} variant="secondary" className="w-[250px] ml-2 mt-2 mb-0"/>}
                        </p>
                    </div>        
                </div>
                <InvoiceList studentInvoiceDetails={studentInvoiceDetails} apiIsLoading={apiIsLoading}/>
            </div>
        </div>
    );
}